import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AppLayout } from "../../../layouts";
import {
  Buttton,
  Cards,
  Header,
  Inputs,
  Modaal,
  NavAndTabs,
  Sides,
} from "../../../components";
import { Col, Container, Form, Row } from "react-bootstrap";
import { actionAdmin, actionDoctor } from "../../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { StarRating } from "../../../utilities/common";
import { useAlert, useToast } from "../../../contexts";
import Accepted from "./accepted";
import Pending from "./pending";

const MyDoctors = ({ loginData }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { showAlert } = useAlert();
  const { showToast } = useToast();
  const [showModal1, setShowModal1] = useState(false);
  const [activeTab, setActiveTab] = useState("accepted");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [errors, setErrors] = useState({});
  const [selectedDoctorGuid, setSelectedDoctorGuid] = useState(null);
  const getDoctersByPhoneNumOrEmailData = useSelector(
    (state) => state.admin.getDoctersByPhoneNumOrEmailData?.data
  );
  const getAllClinicRequestsData = useSelector(
    (state) => state.doctor.getAllClinicRequestsData?.data
  );
  const pendingData = getAllClinicRequestsData?.result.filter(item => item.status === 1);
  const acceptedData = getAllClinicRequestsData?.result.filter(item => item.status === 2);

  useEffect(() => {
    dispatch(actionDoctor.getAllClinicRequests(loginData.clinicGuid, null));
  }, [dispatch, loginData]);


  const onTabChange = (tabId) => {
    setActiveTab(tabId);
    // navigate(`/doctor/my-profile/${tabId}`);
  };
  const handleCloseModal = () => {
    setShowModal1(false);
  };
  const validateEmail = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value);
  };
  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    setPhone("");

    if (validateEmail(value)) {
      setErrors((prev) => {
        const { email, ...rest } = prev;
        return rest;
      });
      dispatch(actionAdmin.getDoctorsByPhoneNumorEmail(value, 1));
    } else {
      setErrors((prev) => ({ ...prev, email: "Invalid email format" }));
    }
  };
  const validatePhone = (value) => {
    const phoneRegex = /^[0-9]{10}$/;
    return phoneRegex.test(value);
  };
  const handlePhoneChange = (e) => {
    const value = e.target.value;
    setPhone(value);
    setEmail("");

    if (validatePhone(value)) {
      setErrors((prev) => {
        const { phone, ...rest } = prev;
        return rest;
      });
      dispatch(actionAdmin.getDoctorsByPhoneNumorEmail(value, 1));
    } else {
      setErrors((prev) => ({
        ...prev,
        phone: "Phone number must be 10 digits",
      }));
    }
  };

  const handleClick = () => {
    const credentials = {
      DoctorClinicRequestGuid: null,
      ClinicGuid: loginData.clinicGuid,
      DoctorGuid: selectedDoctorGuid,
      status: 1,
    }

    dispatch(
      actionDoctor.postSendDoctorClinicRequest(credentials, (error, response) => {
        if (error) {
          if (error.data) {
            if (error.data.statusCode === 400) {
              if (error.data.message) {
                showAlert(
                  "danger",
                  error.data.message,
                  `${t("Error")} : `
                );
              } else {
                if (error.data.error && error.data.error.ValidationErrors) {
                  error.data.error.ValidationErrors.forEach((validationError) => {
                    console.error(
                      `${t("Field")}: ${validationError.Field} - ${t(
                        "Message"
                      )}: ${validationError.Message}`
                    );

                    showAlert(
                      "danger",
                      validationError.Message,
                      `${t("Error")} : ${validationError.Field}`
                    );
                  });
                } else {
                  showAlert(
                    "danger",
                    `${t("Invalid_credentials")}`,
                    `${t("Error")} !`
                  );
                }
              }

            } else {
              showAlert("danger", `${t("unexpected_error")}``${t("Error")} !`);
            }
          }
        } else if (response) {
          if (response.status === 200) {
            showToast(
              t("success"),
              t("doctor.my_doctor.add_doctor_success"),
              5000,
              true,
              "top-end toast-success"
            );
            dispatch(actionDoctor.getAllClinicRequests(loginData.clinicGuid, null));
            setActiveTab("pending")
            setShowModal1(false)
          }
        }
      })
    );
  }

  const tabs = [
    {
      id: "accepted",
      label: t("accepted"),
      content: (<Accepted acceptedData={acceptedData} loginData={loginData} />),
      disabled: false,
    },
    {
      id: "pending",
      label: t("pending"),
      content: (<Pending pendingData={pendingData} />),
      disabled: false,
    },
  ];
  const buttons = (
    <>
      <Buttton.Buttton
        children={t("add_specialist")}
        className="btn-solid-Aqua_Teal"
        onClick={() => setShowModal1(true)}
      />
    </>
  );
  const rightSide = (
    <Container fluid className="exado-container1">
      <Row className="exado-row1">
        <Col>
          <Header.HeadingPage pageHeading="My Doctors" buttons={buttons} />
        </Col>
      </Row>
      <Row className="exado-row1">
        <Col>
          <NavAndTabs.NavAndTabs
            tabs={tabs}
            activeTab={activeTab}
            onTabChange={onTabChange}
          />
        </Col>
      </Row>
    </Container>
  );

  return (
    <>
      <AppLayout.AppLayoutOne
        leftSide={<Sides.LeftSides loginData={loginData} />}
        rightSide={rightSide}
      />

      <Modaal.Modaal
        show={showModal1}
        onHide={handleCloseModal}
        centered="true"
        size="xl"
        title={<h2 className="exado-title-nine">{t("add_specialist")}</h2>}
        bodyContent={
          <>
            <Row className="pro-row">
              <Form.Label className="exado-title-six">
                {t("Contact")} {t("Information")}
              </Form.Label>
              <Col>
                <Row>
                  <Inputs.FormInputs
                    placeholder={t("email") + " " + t("Address")}
                    label={
                      errors.email ? (
                        <span className="error-message">{errors.email}</span>
                      ) : (
                        t("email") + " " + t("Address")
                      )
                    }
                    name="email"
                    value={email}
                    onChange={handleEmailChange}
                    grpClassname={`form-group ${errors.email ? "form-group-error" : ""
                      }`}
                    disabled={!!phone.trim()}
                    setEmail
                  />
                </Row>
              </Col>
              <Col>
                <Row>
                  <Inputs.FormInputs
                    placeholder={t("phone_number")}
                    label={
                      errors.phone ? (
                        <span className="error-message">{errors.phone}</span>
                      ) : (
                        t("phone_number")
                      )
                    }
                    name="phone"
                    maxLength={10}
                    value={phone}
                    onChange={handlePhoneChange}
                    grpClassname={`form-group ${errors.phone ? "form-group-error" : ""
                      }`}
                    disabled={!!email.trim()}
                  />
                </Row>
              </Col>
            </Row>
            <Row className="pro-row">
              {getDoctersByPhoneNumOrEmailData?.result?.map((doctor, index) => (
                <Col key={index} md={6}>
                  <Cards.HCardd
                    className={`Hcardd ${selectedDoctorGuid === doctor.doctorGuid ? "selected-card" : ""
                      }`}
                    imageSrc={doctor.profileImage}
                    cardBody={
                      <>
                        <h5 className="exado-title-seven">{doctor.firstName + " " + doctor.lastName}</h5>
                        <p>
                          {doctor.physicianServices.map((Services) => (
                            <span className="exado-title-six">{Services.physicianServiceName}</span>
                          ))}
                        </p>

                        <StarRating rating={doctor.rating} />
                        <p className="exado-title-six exp-color" >{doctor.experience} {t("doctor.my_doctor.experience_overall")}</p>
                      </>
                    }
                    title={doctor.firstName + " " + doctor.lastName}
                    onClick={() => setSelectedDoctorGuid(doctor.doctorGuid)}
                  />
                </Col>
              ))}
            </Row>
          </>
        }
        footer={
          <Buttton.Buttton
            children={t("save")}
            className="btn-solid-Aqua_Teal"
            onClick={handleClick}
            disabled={!selectedDoctorGuid}
          />
        }
        backdrop="static"
        className="input-modal addspecialist"
      />
    </>
  );
};

export default MyDoctors;
